module.exports = __webpack_public_path__ + "static/media/map-marker-edit.a060c074.svg";